import {createSelector, select} from '@ngrx/store';
import {AppState} from "../app.state";
import {GlobalSearchState} from "./global-search.reducer";


export const selectGlobalSearch = (state: AppState) => state.globalSearches;

export const selectGlobalSearchResults = createSelector(
  selectGlobalSearch,
  (state: GlobalSearchState) => state.globalSearchResult
);

export const selectGlobalSearchStatus = createSelector(
  selectGlobalSearch,
  (state: GlobalSearchState) => state.status
);

